<template>
  <div>
    <Form :model="setting" :label-width="200" inline>
      <FormItem label="是否强制替换轮播图">
        <i-switch
          v-model="setting.is_replace_banner"
          size="large"
          @on-change="(value)=>{onChange('is_replace_banner', value)}"
        >
          <span slot="open">显示</span>
          <span slot="close">隐藏</span>
        </i-switch>
      </FormItem>
      <FormItem label="门店线下充值">
        <i-switch
          v-model="setting.is_offline_bill"
          size="large"
          @on-change="(value)=>{onChange('is_offline_bill', value)}"
        >
          <span slot="open">能</span>
          <span slot="close">否</span>
        </i-switch>
      </FormItem>
      <FormItem label="门店线上充值">
        <i-switch
          v-model="setting.is_online_bill"
          size="large"
          @on-change="(value)=>{onChange('is_online_bill', value)}"
        >
          <span slot="open">能</span>
          <span slot="close">否</span>
        </i-switch>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      switch1: false
    }
  },
  created () {
    this.display()
  },
  computed: {
    ...mapGetters('setting', ['setting'])
  },
  methods: {
    ...mapActions('setting', ['display', 'upgrade']),
    onChange (key, value) {
      const params = {}
      params[key] = value
      this.upgrade(params)
    }
  }
}
</script>
